export default __webpack_public_path__ + "static/media/shrewdblow5.bed0093c.png";